import React from "react";

export default function Card({ children , className}) {
  return <div className={`rounded-lg bg-white p-5 shadow-lg ${className ?? ''}`}>{children}</div>;
}
